import { CodecUtils } from 'common/utils/codec-utils';

export enum InvitationType {
  CompanyInvitation = 'SubscriptionInvitation',
  WorkPackageInvitation = 'WorkPackageInvitation',
  ProjectInvitation = 'ProjectInvitation',
  CombinedInvitation = 'CombinedInvitation',
}

export const InvitationTypeC = CodecUtils.createEnumCodec<InvitationType>(InvitationType, 'InvitationType');
